import { createRoot } from 'react-dom/client';
import React from 'react';

import Terms from '../components/Terms';
import ProgressReport from '../components/ProgressReport';
import PrimeTermsModal from '../components/PrimeTermsModal';
import PledgeFirstTitleModal from '../components/PledgeFirstTitleModal';
import CustomEmailTemplateModal from '../components/CustomEmailTemplateModal';
import AddressChangeModal from '../components/AddressChangeModal';
import ReactivatePrimeBanner from '@components/ReactivatePrimeBanner';
import TeamInvitationPendingModal from '@components/TeamInvitationPendingModal';
import TrialBanner from '@components/TrialBanner';
import WelcomeTeamsBanner from '@components/WelcomeTeamsBanner';
import PledgeFirstTitleBanner from '@components/PledgeFirstTitleBanner';

import '@stylesheets/support/base.scss';
import { logCrmEvent } from '@javascripts/util/eventLogging';

document.addEventListener('DOMContentLoaded', () => {
  const termsContainer = document.getElementById('terms-container');
  const progressReportComponent = document.getElementById('progress-report-wrapper');
  const primeTermsContainer = document.getElementById('prime-terms-acceptance-wrapper');
  const pledgeFirstTitleContainer = document.getElementById('pledge-first-title-wrapper');
  const customEmailTemplateContainer = document.getElementById('custom-email-template-wrapper');
  const addressChangeContainer = document.getElementById('address-change-wrapper');
  const reactivatePrimeBannerContainer = document.getElementById('reactivate-prime-banner');
  const teamInvitationPendingContainer = document.getElementById('team-invitation-pending-wrapper');
  const trialBannerContainer = document.getElementById('trial-banner');
  const welcomeTeamsBannerContainer = document.getElementById('welcome-teams-banner');
  const pledgeFirstTitleBannerContainer = document.getElementById('pledge-first-title-banner');

  if (termsContainer) {
    const data = JSON.parse(termsContainer.getAttribute('data'));
    const root = createRoot(termsContainer);
    root.render(<Terms data={data} />);
    logCrmEvent('disruptor_viewed', { type: 'agent_terms' });
  }

  if (progressReportComponent) {
    const data = JSON.parse(progressReportComponent.getAttribute('data'));
    const root = createRoot(progressReportComponent);
    root.render(<ProgressReport data={data} />);
    logCrmEvent('disruptor_viewed', { type: 'progress_report', match_id: data.match_id });
  }

  if (primeTermsContainer) {
    const data = JSON.parse(primeTermsContainer.getAttribute('data'));
    const root = createRoot(primeTermsContainer);
    root.render(<PrimeTermsModal data={data} />);
    logCrmEvent('disruptor_viewed', { type: 'prime_terms' });
  }

  if (pledgeFirstTitleContainer) {
    const root = createRoot(pledgeFirstTitleContainer);
    root.render(<PledgeFirstTitleModal />);
    logCrmEvent('disruptor_viewed', { type: 'pledge_first_title' });
  }

  if (customEmailTemplateContainer) {
    const root = createRoot(customEmailTemplateContainer);
    root.render(<CustomEmailTemplateModal />);
    logCrmEvent('disruptor_viewed', { type: 'custom_email_template' });
  }

  if (addressChangeContainer) {
    const root = createRoot(addressChangeContainer);
    root.render(<AddressChangeModal />);
    logCrmEvent('disruptor_viewed', { type: 'us_bank_address_change' });
  }

  if (trialBannerContainer) {
    const data = JSON.parse(trialBannerContainer.getAttribute('data-props'));
    const root = createRoot(trialBannerContainer);
    root.render(<TrialBanner data={data} />);
  }

  if (welcomeTeamsBannerContainer) {
    const data = JSON.parse(welcomeTeamsBannerContainer.getAttribute('data-props'));
    const root = createRoot(welcomeTeamsBannerContainer);
    root.render(<WelcomeTeamsBanner data={data} />);
  }

  if (pledgeFirstTitleBannerContainer) {
    const data = JSON.parse(pledgeFirstTitleBannerContainer.getAttribute('data-props'));
    const root = createRoot(pledgeFirstTitleBannerContainer);
    root.render(<PledgeFirstTitleBanner data={data} />);
  }

  if (teamInvitationPendingContainer) {
    const data = JSON.parse(teamInvitationPendingContainer.getAttribute('data'));
    const root = createRoot(teamInvitationPendingContainer);

    root.render(<TeamInvitationPendingModal data={data}/>);
    logCrmEvent('disruptor_viewed', { type: 'team_invitation_pending' });
  }

  if (reactivatePrimeBannerContainer) {
    const data = JSON.parse(reactivatePrimeBannerContainer.getAttribute('data-props'));
    const root = createRoot(reactivatePrimeBannerContainer);

    root.render(
      <ReactivatePrimeBanner data={data} />
    );
  }
});
